import { render, staticRenderFns } from "./teachers-week.vue?vue&type=template&id=42c3061e&"
import script from "./teachers-week.vue?vue&type=script&lang=js&"
export * from "./teachers-week.vue?vue&type=script&lang=js&"
import style0 from "./teachers-week.vue?vue&type=style&index=0&id=42c3061e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports